import { VERSIONS_COPSOQ3, type VersionCopsoq3Enum } from "@repo/utils";
import { Label, RadioGroup, RadioGroupItem } from "@repo/ui";

/**
 * Version du COPSOQ III que passeront les candidats des campagnes à venir de
 * l'organisation. Une campagne fige la sienne à sa création.
 */
export function ChoixVersionCopsoq3({
  value,
  onChange,
}: {
  value: VersionCopsoq3Enum;
  onChange: (version: VersionCopsoq3Enum) => void;
}) {
  return (
    // `fieldset`/`legend` : un groupe de boutons radio, pas un champ unique.
    // Affiché sous la case COPSOQ III (`ChoixApplications`) : la case nomme
    // déjà l'épreuve, la légende ne sert qu'aux lecteurs d'écran.
    <fieldset>
      <legend className="sr-only">Version COPSOQ III</legend>
      <RadioGroup
        value={value}
        onValueChange={(v) => onChange(v as VersionCopsoq3Enum)}
        className="flex flex-wrap gap-x-6 gap-y-2"
      >
        {VERSIONS_COPSOQ3.map((version) => {
          const id = `version-copsoq3-${version.cle}`;
          return (
            <div key={version.cle} className="flex items-center gap-2">
              <RadioGroupItem value={version.cle} id={id} />
              <Label htmlFor={id} className="cursor-pointer">
                {version.libelle}
              </Label>
            </div>
          );
        })}
      </RadioGroup>
      <p className="text-xs text-muted-foreground mt-2">
        S'applique aux campagnes créées ensuite : les campagnes existantes
        gardent leur version.
      </p>
    </fieldset>
  );
}
